import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import {
  MappingJobStep,
  MappingJobStepProgressByName,
} from '../models/mapping-job-step.js'
import {
  MappingJob,
  MappingJobCancelRequest,
  MappingJobProgress,
  TaskReference,
} from '../models/mapping-job.js'

const serviceSource = 'droidmap.backend.mapping-job-service'
const pipelineSource = 'droidmap.backend.mapping-job-pipeline'

export const MappingJobCreated = new BaseEventBuilder<
  MappingJob,
  'Mapping Job Created'
>(serviceSource, 'Mapping Job Created')

export const MappingJobDeleted = new BaseEventBuilder<
  MappingJob,
  'Mapping Job Deleted'
>(serviceSource, 'Mapping Job Deleted')

/**
 * A user asked for a running job to be cancelled. Consumed by the pipeline's
 * `cancel-mapping-job` Lambda, which fails the execution's outstanding task
 * token so the job runs its normal clean-up path to `Job Cancelled`.
 */
export const MappingJobCancelRequested = new BaseEventBuilder<
  MappingJobCancelRequest,
  'Mapping Job Cancel Requested'
>(serviceSource, 'Mapping Job Cancel Requested')

export const MappingJobProgressed = new BaseEventBuilder<
  MappingJobProgress,
  'Mapping Job Progressed'
>(pipelineSource, 'Mapping Job Progressed')

export const TaskReferenceCreated = new BaseEventBuilder<
  TaskReference,
  'Task Reference Created'
>(serviceSource, 'Task Reference Created')

export const MappingJobStepCreated = new BaseEventBuilder<
  MappingJobStep,
  'Mapping Job Step Created'
>(serviceSource, 'Mapping Job Step Created')

export const MappingJobStepUpdated = new BaseEventBuilder<
  MappingJobStep,
  'Mapping Job Step Updated'
>(serviceSource, 'Mapping Job Step Updated')

// This is a temporary measure to allow updating steps by name.
// TODO: Remove this when we have implemented our own state machine.
export const MappingJobStepProgressedByName = new BaseEventBuilder<
  MappingJobStepProgressByName,
  'Mapping Job Step Progressed'
>(pipelineSource, 'Mapping Job Step Progressed')

export const MappingJobStepDeleted = new BaseEventBuilder<
  MappingJobStep,
  'Mapping Job Step Deleted'
>(serviceSource, 'Mapping Job Step Deleted')

export const SpotInterruptionWarningWithIpAddress = new BaseEventBuilder<
  {
    instanceId: string
    instanceAction: string
    ipAddress: string
  },
  'Spot Interruption Warning with IP Address'
>(serviceSource, 'Spot Interruption Warning with IP Address')
